import { Action, ActionReducer } from '@ngrx/store';
import { cloneDeep } from 'lodash-es';
import * as AuthStoreActions from './auth-store.actions';
import { AuthStoreState } from './auth-store.model';

const initialState = new AuthStoreState();
export function reducer(
  state: AuthStoreState = initialState,
  action: AuthStoreActions.All,
): AuthStoreState {
  switch (action.type) {
    case AuthStoreActions.TOKEN_LOADED: {
      return state.withMutations((s) => {
        s.token = action.token;
        const oktaClaims = cloneDeep(action.oktaClaims);
        Object.freeze(oktaClaims);
        s.oktaClaims = oktaClaims;
      });
    }
    case AuthStoreActions.LOGGED_OUT: {
      return initialState;
    }
  }
  return state;
}

export const authReducer: ActionReducer<AuthStoreState, Action> = reducer as ActionReducer<
  AuthStoreState,
  Action
>;
